import { render, staticRenderFns } from "./TravellerView.vue?vue&type=template&id=0975ca70&scoped=true&"
import script from "./TravellerView.vue?vue&type=script&lang=js&"
export * from "./TravellerView.vue?vue&type=script&lang=js&"
import style0 from "./TravellerView.vue?vue&type=style&index=0&id=0975ca70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975ca70",
  null
  
)

export default component.exports